<template>
  <v-layout column fill-height fill-width>
    <v-card>
      <v-card-title>
        Choose a Job
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-checkbox
          :label="`Show Done`"
          v-model="includeFinalized"
          @click.native="loadJobList"
        ></v-checkbox>
        <v-dialog v-model="dialog" persistent max-width="800px">
          <v-btn slot="activator" color="indigo" dark>
            <v-icon dark>date_range</v-icon>
          </v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">Job Date Range</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <!--begin date-->
                  <v-flex xs12 lg6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu1"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="beginDateFormat"
                        label="Begin Date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!--end date-->
                  <v-flex xs12 lg6>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="endDateFormat"
                        label="End Date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="resetDateRange">Close</v-btn>
              <v-btn color="blue darken-1" flat @click.native="loadJobList">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn color="indigo" dark width="50" @click.native="loadJobList">
          <v-icon dark>refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="jobs"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.jobName }}</td>
          <td class="text-xs-left">{{ props.item.jobDate }}</td>
          <td class="text-xs-left">{{ props.item.jobStatus }}</td>
          <td>
            <v-btn v-if="($can('resort', 'job') || $can('is', 'admin'))" small color="primary" @click.native="openHighRiskDialog(props.item.rawId, 'resortjob', 'Are you SURE you want to re-sort this jobs photos? This will delete any existing photos and set the job back to the ListIn state')">Resort Photos</v-btn>
            <v-btn v-if="($can('delete', 'job') || $can('is', 'admin'))" small color="error" @click.native="openHighRiskDialog(props.item.rawId, 'deletejob', 'Are you SURE you want to completely delete this job? This will remove everything about this job. (photos, subjects, analysis, list files, etc.)')">Delete Job</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        dark
        fab
        fixed
        bottom
        right
        color="indigo"
        @click="toTop"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fab-transition>

    <HighRiskConfirmDialog :visible="confirmDialog" @close="confirmDialog=false" :confirm-string="jobIdToModify" :confirm-message="highRiskConfirmMessage" :action-type="highRiskActionType" @confirmed="performHighRiskAction"></HighRiskConfirmDialog>
  </v-layout>
</template>

<script>
  import HighRiskConfirmDialog from '../../components/dialogs/HighRiskConfirmDialog'

  export default {
    name: "JobPage",
        components: {
          HighRiskConfirmDialog
        },
    data() {
      return {
        search: '',
        confirmDialog: false,
        highRiskActionType: '',
        highRiskConfirmMessage: '',
        jobIdToModify: '',
        includeFinalized: false,
        dialog: false,
        beginDate: null,
        endDate: null,
        date1: null,
        date2: null,
        dateFormatted: null,
        menu1: false,
        menu2: false,
        fab: false,
        headers: [
          {text: 'Job ID', value: 'jobName'},
          {text: 'Job Date', value: 'jobDate'},
          {text: 'Status', value: 'jobStatus'},
          {text: 'Actions', value: 'actions'}
        ],
        jobs: []
      }
    },
    computed: {
      beginDateFormat() {
        return this.formatDate(this.date1)
      },
      endDateFormat() {
        return this.formatDate(this.date2)
      }
    },
    watch: {
      date(val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },
    methods: {
      openHighRiskDialog(jobname, actiontype, confirmstring){
        this.jobIdToModify = jobname;
        this.highRiskConfirmMessage = confirmstring;
        this.highRiskActionType = actiontype;
        this.confirmDialog = true;
      },
      performHighRiskAction(value){
        var jobid = value.confirmString;
        if(value.actionType === "deletejob"){
          console.log("Confirmed delete job for " + jobid);
          this.confirmDialog = false;


          this.$http.post('/job/'+jobid+'/delete', {jobid: jobid}, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(response => {
              if (response.data.success) {
                this.$root.$emit('snackbar', response.data.msg)

              } else {
                this.$root.$emit('snackbar', response.data.msg)
              }

              this.loadJobList();
            })
            .catch(e => {
              // console.log(JSON.stringify(e));
              this.$root.$emit('snackbar', 'Error deleting job '+id)
            })
        }else if(value.actionType === "resortjob"){
          console.log("Confirmed resort job for " + jobid);

          this.confirmDialog = false;


          this.$http.post('/job/'+jobid+'/resort', {jobid: jobid}, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(response => {
              if (response.data.success) {
                this.$root.$emit('snackbar', response.data.msg)

              } else {
                this.$root.$emit('snackbar', response.data.msg)
              }

              this.loadJobList();
            })
            .catch(e => {
              // console.log(JSON.stringify(e));
              this.$root.$emit('snackbar', 'Error setting job to resorting photos/listin'+id)
            })
        }
      },
      resortJob(id){
        console.log("Handle resort " + id);

      },
      loadJobList() {
        this.beginDate = this.date1;
        this.endDate = this.date2;
        this.dialog = false;
        this.$http.get('/jobs/yearrange/' + this.beginDate + '/' + this.endDate + '/' + this.includeFinalized, {
          headers: {
            'Authorization': localStorage.getItem('apiKey')
          }
        })
          .then(response => {
            this.jobs = [];
            for (var i = 0; i < Object.keys(response.data).length; i++) {

              var job = response.data[i];

              var job_id = String(job.job_id).toUpperCase().split("_")[1];
              var job_date = this.dateFormatUTC(job.date);
              var job_status = job.status;
              var job_finalized_date = job.finalized_date;
              var job_formsimported = job.formsimported;
              var job_notes = job.notes;

              this.jobs.push({
                rawId: job.job_id,
                jobName: job_id,
                jobDate: job_date,
                jobStatus: job_status,
                jobFormStatus: job_formsimported,
                jobFinalizedDate: job_finalized_date,
                jobNotes: job_notes
              });
            }
            console.log(this.users);
          })
          .catch(e => {
            this.$root.$emit('snackbar', 'Error retrieving user list!')
            console.log(e);
          })
      },
      resetDateRange() {
        this.date1 = this.beginDate;
        this.date2 = this.endDate;
        this.dialog = false;
      },
      dateFormatUTC(rawDate) {
        var date_Raw = new Date(Date.parse(rawDate));
        var formattedDate = (date_Raw.getUTCMonth() + 1) + "-" + (date_Raw.getUTCDate()) + "-" + date_Raw.getUTCFullYear();
        return formattedDate;
      },
      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate(date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      onScroll() {
        if (typeof window === "undefined") return;
        const top = window.pageYOffset || document.documentElement.offsetTop || 0;
        this.fab = top > 100;
      },
      toTop() {
        this.$vuetify.goTo(0);
      }
    },
    mounted() {
      // get fiscal year
      var currentDate = new Date();
      // month is before july
      if (currentDate.getMonth() <= 5) {
        this.date1 = String(currentDate.getFullYear() - 1) + '-07-01';
        this.date2 = String(currentDate.getFullYear()) + '-07-01';
      } else {
        this.date1 = String(currentDate.getFullYear()) + '-07-01';
        this.date2 = String(currentDate.getFullYear() + 1) + '-07-01';
      }
      // load job list
      this.loadJobList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/analyzer/JobPage.vue